import React from 'react';

const PauseBtn = () => {
  return (
    <svg width='100%' height='100%' viewBox='0 0 57 89' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        opacity='0.6'
        d='M0.250377 0.25H20.75V19.7778V55.625L20.7496 88.75H10.5002H0.250003L0.250377 55.625V0.25Z'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='0.5'
      />
      <path
        opacity='0.6'
        d='M36.2504 0.25H56.75V19.7778V55.625L56.7496 88.75H46.5002H36.25L36.2504 55.625V0.25Z'
        fill='#D9D9D9'
        stroke='black'
        strokeWidth='0.5'
      />
    </svg>
  );
};

export default PauseBtn;
